export default [
    {
        path: 'questionnaire/questionnaireUserPersonalDetail',
        component: () => import('@/views/questionnaire/questionnaireUserPersonalDetail'), // 问卷详情
        meta: {
            permissionPath: '/vote/getVoteListV2'
        }
    },
    {
        path: 'questionnaire/questionnairePersonalList',
        component: () => import('@/views/questionnaire/questionnairePersonalList'), // 用户问卷列表
        meta: {
            permissionPath: '/vote/voteListByUserPagePCV2'
        }
    },
    {
        path: 'questionnaire/questionnaire',
        component: () => import('@/views/questionnaire/questionnaire'),
        meta: {
            permissionPath: '/vote/voteListByUserPagePCV2'
        }
    },
   ]



// WEBPACK FOOTER //
// ./src/router/questionnaire.js